import { useQueryClient } from '@tanstack/react-query'
import { App } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const useDeleteQueryItem = () => {
  const queryClient = useQueryClient()
  const { notification } = App.useApp()
  const { t } = useTranslation()

  const deleteQueryItem = useMemo(
    () => (itemToDelete: any, idFieldName: string, options: any) => {
      queryClient.setQueryData(options.queryKey, (oldItems: any[] = []) => {
        return oldItems.filter(item => item[idFieldName] !== itemToDelete[idFieldName])
      })
      notification.success({ message: t('messages:deleteSuccess', 'Success') })
    },
    [queryClient, notification, t]
  )

  return deleteQueryItem
}

export default useDeleteQueryItem
